<template>
    <div >
      <MdTitle v-bind:Text="$t('DrugsMovementRep.ReportTitle')" />
      <div class="row">
          <div class="col-sm-12 col-md-12 mb-4">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group" dir="ltr">
                      <input 
                        type="text" 
                        class="form-control"
                        :dir="dirInput"
                        v-model="parameter.SearchCriteria"   
                          @keyup.enter="LoadDrugsMovement"                            
                      >
                      <div class="input-group-append">
                          <div class="input-group-append">
                          <MdButton 
                            v-bind:Name="'btnsearchinput'"
                            v-bind:VariantProp="'btn btn-sm search-attached'"
                            v-bind:IconClass="'mdi mdi-magnify'"
                            v-on:click="LoadDrugsMovement">
                          </MdButton>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      
      <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdDateTime 
              :Label="$t('Shared.datefrom')" 
              :Model="dateFrom"                           
              @input="dateFrom = $event"                            
              :Id="'DrugsMovementRepDateFrom'"
              :Type="'date'"  
              :OnPressEnter="LoadDrugsMovement"            
              :isRequired="false"                           
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateFromValid">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdDateTime 
                :Label="$t('Shared.dateTo')" 
                :Model="dateTo"                           
                @input="dateTo = $event"                            
                :Id="'DrugsMovementRepDateTo'"
                :OnPressEnter="LoadDrugsMovement"    
                :Type="'date'"             
                :isRequired="false"                           
                :isConfirm="false"
                :ReadOnly="false"
                v-bind:isValid="isDateToValid">
            </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">         
            <MdLookupMultiSelect
                v-bind:Label="$tc('Shared.Patient',2)"
                v-bind:ModelCode="PatientCodeModel"
                v-bind:RefCode="'patientcode'"
                v-bind:Api="'Patients'"
                v-bind:FieldCode="'patientcode'"
                v-bind:FieldDescription="'firstname'"
                :SearchTitle="$tc('Shared.Patient',2)"
                :GetValues="getValues"
                :InvalidFeedback="$t('Msg.InvalidCode')"
                :SearchFieldCode="'PatientCode'"
                :AuxFields="AuxFields"
                :FieldsDate="fieldsDate"
                :ServerSidePagination="true"
                v-bind:Fields="BaseFields"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">         
            <MdLookupMultiSelect
                v-bind:Label="$t('Medication.Drugs')"
                v-bind:ModelCode=DrugsCodeModel
                v-bind:RefCode="'DrugsCode'"
                v-bind:Api="'Drugs'"
                v-bind:FieldCode="'drugCode'"
                v-bind:FieldDescription="'drugname'"
                :SearchTitle="$t('Medication.Drugs')"
                :GetValues="getValuesDrugs"
                :InvalidFeedback="$t('Msg.InvalidCode')"
                :SearchFieldCode="'Code'"
                :AuxFields="AuxFieldsDrugs"
                :ServerSidePagination="true"
                v-bind:Fields="BaseFieldsDrugs"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$tc('ePharmacyItemsReceived.Location')"
                v-bind:Options="LocList"
                v-bind:Model="LocCodeModel"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'" 
                v-bind:Multiple="true"                      
                :Input="ChangeLocation"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
             <MdSelect
              v-bind:Label="$tc('Shared.DrugType')"
              v-bind:Options="DrugTypeList"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Multiple="true"
              v-bind:Model="DrugTypeModel"  
              :Input="ChangeDrugType"
              :SortAlphabetical="true"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Trans')"
              v-bind:Options="TranOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:AllowEmpty="true"
              v-bind:Multiple="true"
              v-bind:Model="TranModel"  
              :Input="ChangeTran"
              :SortAlphabetical="true"
              :UseTitleCase="true"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdRadioGroup
              v-bind:Label="$t('Shared.OrderBy')"
              v-model="order"
              v-bind:Options="orderOptions"
              v-bind:Name="'order'"
            />
          </b-col>
          <b-col lg="9" md="9" sm="12"></b-col>
          <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadDrugsMovement"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col> 
     
        </b-row>
        <div class="row">
          <div class="col-12 mt-2">
             <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

            <div class="row">
              <div class="col-md-12">
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    v-bind:FieldsDate="FieldsDateArr">
                  </MdTable>
              </div>
            </div>
          </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>

          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   
        </div>

      
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('DrugsMovementRep.ReportTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportDrugsMovementFilters"
          :ReportName="'DrugsMovement'"
          :ReportTitle="$t('DrugsMovementRep.ReportTitle')"
          :IsAnAPIReport="true"
        />
    </DxPopup>

    <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('DrugsMovementRep.ReportTitle')"
        v-bind:sendEmailAPI="'/Utils/sendEmail'"
        v-bind:exportCsvAPI="'/Drugs/Movement/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import PharmacyRepFunctions from '@/common/PharmacyRepFunctions.js'
  import { EventBus } from '@/event-bus.js';
  import UtilsService from '@/services/utils.service'
  import Utils from '@/common/utils'
  import StorageService from '@/services/storage.service'


  export default Vue.extend({
      name: "DrugsMovementRep",
      mixins: [ ShowMessage, DBFunctions, PharmacyRepFunctions ],
      components: { DxPopup },
      data() {
          return {
              isParamVisible: true,
              isReportVisible: false,
              dateFrom: null,
              dateTo: null,
              reportParams: [],
              DrugList:[],
              PatientsList: [],
              PatientCodeModel: [],
              DrugsCodeModel: [],
              LocCodeModel:'',
              LocList:[],
              parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0       
              },
              params: {
                DrugList: '',
                PatientCode: '',
                DrugType: '',
                LocList:'',
                Tran: ''
              },
              DrugTypeModel: '',
              DrugTypeList: [],
              TranModel: '',
              TranOptions: [
                {"value":"RECEIVED","name":this.$t('Shared.Received')},
                {"value":"DISPENSING","name":this.$t('Shared.Dispensing')},
                {"value":"ADMINISTER","name":this.$t('Shared.Administer')},
                {"value":"RELOCATION","name":this.$t('Shared.Relocation')},
                {"value":"RETURNED","name":this.$t('Shared.Returned')},
                {"value":"REMOVED","name":this.$t('Shared.Removed')}
              ],
              orderOptions: [
                { value: '', text: this.$t('Shared.Date') },
                { value: 'DN', text: this.$t('Shared.DrugName') },
                { value: 'TR', text: this.$t('Shared.Trans') }
              ],
              order: '',
              items: [],         
              fields: [
                { key: 'TransDate', sortable: true, label: this.$t('Shared.TransactionDate'), class: 'text-left' },
                { key: 'Trans', sortable: true, label: this.$t('Shared.Trans'), class: 'text-left' },
                { key: 'DrugCode', sortable: true, label: this.$t('Shared.DrugCode'), class: 'text-left' },
                { key: 'DrugName', sortable: true, label: this.$t('Shared.DrugName'), class: 'text-left' },
                { key: 'Quantity', sortable: true, label: this.$t('Shared.quantity'), class: 'text-center' },
                { key: 'NameLocationFrom', sortable: true, label: this.$t('Shared.Location'), class: 'text-left' },
                { key: 'UserName', sortable: true, label: this.$t('Shared.User'), class: 'text-left' },
                { key: 'Destination', sortable: true, label: this.$t('DrugsMovementRep.Destination'), class: 'text-left' },
              ],
              pageOptions: [5, 10, 15 ],
              totalRows: 0,
              currentPage: 1,
              perPage: 10,
              selected: [],
              Header:{},
              refTable: 'selectableTable', 
              ShowMessageIsEmpty:true,
              FieldsDateArr:['TransDate'],
              dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
              AuxFields:['lastname'],
              AuxFieldsDrugs:['status'],
              fieldsDate:['dob'],
              BaseFields:[
                  { key: 'firstname', sortable: true, label: this.$t('Shared.FirstName') },
                  { key: 'lastname', sortable: true, label: this.$t('Shared.LastName')},
                  { key: 'patientcode', sortable: true, label: this.$t('Shared.Code')},
                  { key: 'dob', sortable: true, label: this.$t('Shared.Dob')},
                  { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone')},
                  { key: 'address1', sortable: true, label: this.$t('Shared.Address1')},
                  { key: 'city', sortable: true, label: this.$t('Shared.City')},
                  { key: 'state', sortable: true, label: this.$t('Shared.State')},
                  { key: 'country', sortable: true, label: this.$t('Shared.Country')},
                  { key: 'zip', sortable: true, label: this.$t('Shared.Zip')}
              ],
              BaseFieldsDrugs:[
                { key: 'drugname', sortable: true, label: this.$t('Shared.DrugName')},
                { key: 'activeingred', sortable: true, label: this.$t('Shared.activeIngredients')},
                { key: 'dosage', sortable: true, label: this.$t('Shared.Dosage')},
                { key: 'form', sortable: true, label: this.$t('Shared.Form')},
                { key: 'drugCode', sortable: true, label: this.$t('Shared.DrugCode') },
              ],
              isDateFromValid: true,
              isDateToValid: true,    
          }
      },
      methods: {

          getValues: function (value) {
              this.PatientCodeModel = value
              this.params.PatientCode = value.join(',')
          },

          getValuesDrugs: function (value) {
              this.DrugsCodeModel = value
              this.params.DrugList = value.join(',')
          },

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
          },
          
          ChangeTran(values) {
            var trans = '';
            if (values && values.length > 0) {
                trans = values.map(x => x.value).join(',');
            }
            this.params.Tran = trans; 
          },

          ChangeDropDownPatients(values) {
            var pCodes = '';
            if (values && values.length > 0) {
                pCodes = values.map(x => x.patientcode).join(',');
            }
            this.params.PatientCode = pCodes; 
          },

          customLabelPatients ({ PatientName, patientcode }) {
            return `${PatientName} – ${patientcode}`
          },

          onClickClose() {
            this.isParamVisible = false;
          },

          reportList() {
            this.checkExistFavorite('/app/reports/pharmacy');
            this.$router.push({ name: "reportListPharmacy" }).catch(()=>{});
          },

          initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pStartDate', paramValue: this.dateFrom})
            this.reportParams.push({ paramName: 'pEndDate', paramValue: this.dateTo})
            this.reportParams.push({ paramName: 'pDrugList',paramValue: this.params.DrugList })
            this.reportParams.push({ paramName: 'pPatientCodeList',paramValue: this.params.PatientCode })
            this.reportParams.push({ paramName: 'pDrugType', paramValue: this.params.DrugType})
            this.reportParams.push({ paramName: 'pTran', paramValue: this.params.Tran})
            this.reportParams.push({ paramName: 'pLocList',paramValue: this.params.LocList })
            this.reportParams.push({ paramName: 'pOrder', paramValue: this.order})
            this.reportParams.push({ paramName: 'pSearchCriteria', paramValue: this.parameter.SearchCriteria})
            this.reportParams.push({ paramName: 'isUAE',  paramValue: this.$store.state.companies.isUAE})
          },

          onClickShowReport() {
            this.isParamVisible = false
            this.initializePdfParameters();
            this.isReportVisible = true
            this.$refs.reportDrugsMovementFilters.buildDocument(this.reportParams)
          },

          LoadDrugsMovement() {
            if (!this.validateForm()) return;

            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getListing();
          },

          initializeParameters() {
           
            // Asignaciones condicionales
            this.parameter.DrugList = this.params.DrugList && this.params.DrugList !== '' 
                ? this.params.DrugList 
                : '';
            
            this.parameter.DateFrom = this.dateFrom;
            this.parameter.DateTo = this.dateTo;
            this.parameter.DrugType = this.params.DrugType && this.params.DrugType !== '' 
              ? this.params.DrugType
              : null;
            this.parameter.PatientCodeList = this.params.PatientCode && this.params.PatientCode !== '' 
                ? this.params.PatientCode
                : '';
            this.parameter.Tran = this.params.Tran && this.params.Tran !== '' 
                ? this.params.Tran
                : '';
            this.parameter.LocList = this.params.LocList && this.params.LocList !== '' 
              ? this.params.LocList
              : '';
            this.parameter.order = this.order;
            
            this.parameter.UserId = StorageService.getUserId();  
          },

          getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            const procedureName = 'sp_iss_WebDrugsMovement'; 
            this.initializeParameters();

            const spParameters = {
              SearchCriteria: this.parameter.SearchCriteria,
              DateFrom: this.parameter.DateFrom,
              DateTo: this.parameter.DateTo,
              DrugType: this.parameter.DrugType,
              Locations: this.parameter.LocList,
              Transaction: this.parameter.Tran,
              DrugCode: this.parameter.DrugList,
              PatientCode: this.parameter.PatientCodeList,
              OrderBy: this.parameter.order,
              UserId: this.parameter.UserId,
            };
            
            const request = {
              procedureName: procedureName,
              parameters: spParameters,
              pageNumber: this.parameter.PageNumber,
              pageSize: this.parameter.PageSize
            };
          
            UtilsService.getExecuteSP(request)
              .then(response => {
                  this.ShowMessageIsEmpty = false;
                  if (response.status == "200" && response.data) {
                      this.items = response.data;
                      let headerString = response.headers["x-pagination"];
                      this.Header = JSON.parse(headerString);
                      this.totalRows = this.Header.TotalCount;
                  }
                  if(this.items.length === 0){
                    this.ShowMessageIsEmpty = true;
                  }
              })
              .catch(error => {
                  this.showResponseErrorMessage(error);
              });
          },
          pageChanged (page) {            
            this.currentPage = page;
            this.getListing();    
          },

          PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getListing();
          },

          handleCSV(action) {
            if (!this.validateForm()) return;

            this.initializeParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportCSV(this.parameter);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailCSV(this.parameter);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          handlePdf(action) {
            if (!this.validateForm()) return;

            this.initializePdfParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportToPdf('DrugsMovement', true, false, this.reportParams);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailPdf('DrugsMovement', true, false, this.reportParams);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },
          
          validate_date_range() {
            return Utils.isDateFromAndDateTo(this.dateFrom, this.dateTo);
          },

          // Método de validación reutilizable
          validateForm() {
            const isValid = this.validate_date_range();
       
            this.isDateFromValid = isValid;
            this.isDateToValid = isValid;
            
            // Forzar actualización del componente
            this.$forceUpdate();
            
            if (!isValid) {
              this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), "error");
              return false;
            }
            return true;
          },
      },
      created() {
       
      },

      mounted () {
        this.getLocationsFilter();
        this.getDrugTypeFilter();
        
        EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
      },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
